// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2QIIo","amount":"Amount_amount__25heQ","tip":"Amount_tip__2Hbuy","tipHeader":"Amount_tipHeader__1ete5","tipsWrap":"Amount_tipsWrap__1xm0v"};